import { render, staticRenderFns } from "./RawTable.vue?vue&type=template&id=9d8a74ca&scoped=true"
import script from "./RawTable.vue?vue&type=script&lang=js"
export * from "./RawTable.vue?vue&type=script&lang=js"
import style0 from "./RawTable.vue?vue&type=style&index=0&id=9d8a74ca&prod&lang=scss"
import style1 from "./RawTable.vue?vue&type=style&index=1&id=9d8a74ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d8a74ca",
  null
  
)

export default component.exports